import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Check, Loader2 } from 'lucide-react';
import { PaymentMethod } from '../types';
import { getPaymentMethodColor } from '../utils/statusColors';
interface PaymentMethodPillProps {
  method: PaymentMethod;
  isOpen: boolean;
  isSaving: boolean;
  onToggle: () => void;
  onSelect: (method: PaymentMethod) => void;
}
const methodOptions: PaymentMethod[] = ['Wire', 'ACH', 'Check'];
export function PaymentMethodPill({
  method,
  isOpen,
  isSaving,
  onToggle,
  onSelect
}: PaymentMethodPillProps) {
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        if (isOpen) {
          onToggle();
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onToggle]);
  const handleSelect = (newMethod: PaymentMethod) => {
    onSelect(newMethod);
  };
  return <div ref={dropdownRef} className="relative inline-block min-w-[180px]" data-id="element-249">
      <button onClick={e => {
      e.stopPropagation();
      onToggle();
    }} disabled={isSaving} className={`w-full px-3 py-2 rounded-lg text-sm font-semibold flex items-center justify-between gap-2 transition-colors ${getPaymentMethodColor(method)} ${isSaving ? 'opacity-70 cursor-not-allowed' : ''}`} data-id="element-250">
        <span className="truncate" data-id="element-251">{method || 'Not Set'}</span>
        {isSaving ? <Loader2 className="w-4 h-4 animate-spin" data-id="element-252" /> : <ChevronDown className="w-4 h-4 flex-shrink-0" data-id="element-253" />}
      </button>

      <AnimatePresence data-id="element-254">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.15
      }} className="absolute left-0 top-full mt-1 w-full bg-white rounded-lg border border-slate-200 shadow-lg z-10 py-1" onClick={e => e.stopPropagation()} data-id="element-255">
            {methodOptions.map(option => <button key={option} onClick={() => handleSelect(option)} className={`w-full px-3 py-2 text-sm font-semibold text-left flex items-center justify-between gap-2 transition-colors ${getPaymentMethodColor(option)}`} data-id="element-256">
                <span data-id="element-257">{option}</span>
                {method === option && <Check className="w-4 h-4" data-id="element-258" />}
              </button>)}
          </motion.div>}
      </AnimatePresence>
    </div>;
}